<template>
  <div>
    <QS-scroller-box>
      <!-- title -->
      <QS-h4-title :content="effectDate" title="待租判断标准">
        <el-button slot="right" type="primary" @click="handleCarStandardDataList('refresh')">刷新</el-button>
      </QS-h4-title>
      <!-- 折叠容器 -->
      <el-collapse v-model="activeNames">
        <template>
          <el-collapse-item v-for="(item, index) in collapseData" :name="index + 1" :key="item.title">
            <!-- 标题部分 -->
            <template slot="title">
              {{ item.title }}
              <span class="collapse_sub_title">&nbsp;&nbsp;&nbsp;&nbsp;{{ item.subTitle }}</span>
            </template>
            <!-- 容器内容 -->

            <!-- 待租标准 -->
            <template v-if="index === 0">
              <div class="form_container">
                  <singleSwitch
                    label-width="255"
                    :activeValue="1"
                    :inactiveValue="0"
                    v-for="(everyCondition, index) in carAndLicenseList"
                    v-model="carAndLicenseList[index]"
                    :key="carAndLicenseList[index].id"
                  />
              </div>
            </template>
            <!-- 不可租标签 -->
            <template v-if="index === 1">
              <div class="form_container_tag">
                <div class="form_container_tag_body">
                    <span class="tab_label">打标后不可租</span>
                    <el-select
                      v-model="nonLeaseableTagList"
                      multiple
                      placeholder="请选择"
                      class="tab_select"
                      v-no-removable-default-select="[unableRemoveData]"
                    >
                      <el-option
                        v-for="item in optionalTagList"
                        :key="item.id"
                        :label="item.itemName"
                        :value="item.id"
                        :disabled="!item.mutable"
                      />
                    </el-select>
                  </div>
                <!-- <div class="tag_tips">可在组织-标签进行标签新增等操作</div> -->
              </div>
            </template>
            <!-- 车务状态监控 -->
            <template v-if="index === 2">
              <div class="form_container form_container_direction">
                <singleSwitch
                  label-width="230"
                  :activeValue="1"
                  :inactiveValue="0"
                  v-for="(everyCondition, index) in carMatterList"
                  v-model="carMatterList[index]"
                  :key="carMatterList[index].id"
                />
              </div>
            </template>
          </el-collapse-item>
        </template>
      </el-collapse>
      <!-- 底部按钮 -->
      <template slot="bottomAction">
        <el-button class="reset" @click="resetData" size="mini">
          <span class="buttonName">恢复至当前生效配置</span>
        </el-button>
        <el-button @click="submitHandle" type="primary" size="mini" :loading="submit">提交</el-button>
        </template>
    </QS-scroller-box>
  </div>
</template>
<script>
import singleSwitch from './switch'

import {
  getCarStandardDataList,
  editCarStandardDataList,
} from '@/api/domain/cars'

export default {
  name: 'CarRentStandard',
  components: { singleSwitch },
  data() {
    return {
      // 需要限制输入内容的集合，_2代表限制两位小数，_0代表整数
      // 20-表显里程、11-网约车证有效期大于等于、8-行驶证有效期大于等于、15-交强险有效期大于等于 16-商业险有效期大于等于
      limitList: ['20_2', '11_0', '8_0', '15_0', '16_0'],
      collapseData: [
        {
          title: '车辆信息及证照状态相关信息',
          subTitle: '开启了判断条件后，车辆需要填写相关信息或满足对应条件，才可待租',
        },
        {
          title: '自定义不可租标签',
          subTitle: '添加了不可租标签后，如果在车辆详情标签中勾选了不可租标签，则车辆不可待租',
        },
        {
          title: '车务状态监控',
          subTitle: '开启了判断条件后，监控违章、保养、维修等车务及车况状态，车辆的车务及车况已处理完成才可待租',
        },
      ], // 折叠面板数据
      carAndLicenseList: [], // 待租标准
      optionalTagList: [], // 自定义不可租标签-待选
      nonLeaseableTagList: [], // 自定义不可租标签-打标后不可租
      carMatterList: [], // 车务状态监控
      lastUpdateTime: '',
      submit: false,
      activeNames: [1, 2, 3],
      // resetConfirmText: '重置后，表单内容将恢复默认关闭状态，仅车辆信息中车型、VIN车架号和发动机号会默认开启，事故、维保和违章监控会默认开启，确认要重置么？',
      submitConfirmText: '提交后，变更后的判断规则将会在10分钟内完成车辆状态的更新。更新过程中请勿反复提交。确认要提交么？',
    }
  },
  computed: {
    // 生效时间
    effectDate() {
      return this.lastUpdateTime ? `最新标准生效时间：${this.lastUpdateTime}` : ''
    },
    // 筛选出不可删除的[不可租标签List]
    unableRemoveData() {
      const arr = this.optionalTagList.reduce((total, item) => {
        if (!item.mutable) {
          total = total.concat([item.itemName])
        }
        return total
      }, [])
      return arr
    },
  },
  mounted() {
    // 获取待租标准数据
    this.handleCarStandardDataList()
  },
  methods: {
    // addLimit
    addLimit(value) {
      // 将有输入项的开关加上limit属性
      value.forEach((item) => {
        if (this.limitList.some((ic) => Number(ic.split('_')[0]) === Number(item.itemType))) {
          const findItem = this.limitList.find((ic) => Number(ic.split('_')[0]) === Number(item.itemType))
          item.limit = Number(findItem.split('_')[1])
        }
      })
      return value
    },
    // 获取待租标准数据
    async handleCarStandardDataList(status) {
      const { code, data } = await getCarStandardDataList()
      if (code !== 1) return
      this.carAndLicenseList = this.addLimit(data.carAndLicenseList) || []
      this.nonLeaseableTagList = data.nonLeaseableTagList || []
      this.optionalTagList = data.optionalTagList || []
      this.carMatterList = this.addLimit(data.carMatterList) || []
      this.lastUpdateTime = data.lastUpdateTime || ''
      const toastText = status && status === 'refresh' ? '刷新成功' : '恢复成功'
      status && this.$message.success(toastText)
    },
    // 点击[恢复至当前生效配置]
    async resetData() {
      this.handleCarStandardDataList('resetLastTime')
    },
    // 表单提交
    async submitHandle() {
      if (this.submit) return
      this.submit = true
      try {
        // 校验待租标准中的带阈值的填写是否完整
        const verifyCarDataResult = this.verifyCarAndLicenseData()
        if (!verifyCarDataResult) return

        // 校验车务状态监控中的带阈值的填写是否完整
        const verifyCarMatterDataResult = this.verifyCarMatterData()
        if (!verifyCarMatterDataResult) return

        // 变更标签的state
        const newTagListData = this.changeNonLeaseableTagList()
        const carRentStandardList = { carRentStandardList: [...this.carAndLicenseList, ...newTagListData, ...this.carMatterList] }

        await this.$confirm(this.submitConfirmText, '确认提交', {
          distinguishCancelAndClose: true,
          confirmButtonText: '提交',
          cancelButtonText: '取消',
        }).then(async () => {
          const { code } = await editCarStandardDataList(carRentStandardList)
          if (code === 1) {
            this.$message.success('提交成功')
          }
        }).catch(() => null)
      } finally {
        this.submit = false
      }
    },

    // 校验待租标准中的带阈值的填写是否完整
    verifyCarAndLicenseData() {
      let flag = true
      const hasItemThresholdArray = this.carAndLicenseList.filter((item) => item.hasItemThreshold === true)
      for (let i = 0; i < hasItemThresholdArray.length; i++) {
        if (hasItemThresholdArray[i].state === 1 && !hasItemThresholdArray[i].itemThreshold) {
          flag = false
          this.$message.error('有效期/公里数判断规则填写不全')
          break
        }
      }
      return flag
    },

    // 校验车务状态监控中的带阈值的填写是否完整
    verifyCarMatterData() {
      let flag = true
      const hasItemThresholdArray = this.carMatterList.filter((item) => item.hasItemThreshold === true)
      for (let i = 0; i < hasItemThresholdArray.length; i++) {
        if (hasItemThresholdArray[i].state === 1 && !hasItemThresholdArray[i].itemThreshold) {
          flag = false
          this.$message.error('有效期判断规则填写不全')
          break
        }
      }
      return flag
    },

    // 变更标签数据-已选的数据state变更成1，未选择的数据state变更成0
    changeNonLeaseableTagList() {
      const hasCheckedData = this.nonLeaseableTagList.reduce((total, item) => {
        const someOne = this.optionalTagList.find((it) => Number(it.id) === Number(item))
        someOne.state = 1 // state 代表此标签已启用-服务端需要此值判断
        total = total.concat([someOne])
        return total
      }, [])
      const noCheckedData = this.optionalTagList.reduce((total, item) => {
        if (this.nonLeaseableTagList.indexOf(item.id) === -1) {
          item.state = 0 // state 代表此标签未启用-服务端需要此值判断
          total = total.concat([item])
        }
        return total
      }, [])
      const changedStateTotalList = [...hasCheckedData, ...noCheckedData]
      return changedStateTotalList
    },
  },
}
</script>
<style lang="scss" scoped>
.form_container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.form_container_tag_body {
  display: flex;
  flex-wrap: nowrap;
}
.form_container_direction {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: left;
}
.collapse_sub_title{
  color: #999;
  font-size: 13px;
}
.tab_label {
  margin-right: 10px;
  line-height: 32px;
}
.tab_select {
  flex-grow: 2;
}
.tag_tips {
  font-size: 13px;
  color: #999;
  margin-top: 12px;
  margin-left: 95px;
}
</style>
